export const copyToClipboard = (text: string) => {
  const dummy = document.createElement("textarea");
  dummy.style.opacity = "0";
  document.body.appendChild(dummy);
  dummy.value = text;
  dummy.select();
  document.execCommand("copy");
  document.body.removeChild(dummy);
};
